import { ATTRIBUTE_ACTION_WILDCARD, AttributeDefinitionActionDto, AttributeDefinitionDto, AttributeDto } from '../hooks/useAttributes'

function stringifyValues(value: unknown): string[] {
    if (value === null || value === undefined) {
        return []
    }
    if (Array.isArray(value)) {
        return value.filter(v => v !== null && v !== undefined && String(v).trim() !== '').map(String)
    }
    const s = String(value)
    return s.trim() === '' ? [] : [s]
}

function resolvePerAttribute<T>(
    actions: AttributeDefinitionActionDto[],
    values: string[],
    extractor: (a: AttributeDefinitionActionDto) => T | undefined,
): T | undefined {
    const matched = actions
        .filter(a => a.match !== ATTRIBUTE_ACTION_WILDCARD && values.includes(a.match))
        .map(extractor)
        .find(v => v !== undefined && v !== null)
    if (matched !== undefined) {
        return matched
    }
    return actions
        .filter(a => a.match === ATTRIBUTE_ACTION_WILDCARD)
        .map(extractor)
        .find(v => v !== undefined && v !== null)
}

/**
 * Frontend mirror of nl.hammock.server.service.AttributeActionResolver for single-value action
 * fields (e.g. organisationProfileKey). Returns the first non-null/undefined value found across
 * all attributes; per attribute non-wildcard matches take precedence over wildcard fallbacks.
 */
export function resolveSingleValueAction<T>(
    attributes: AttributeDto[] | undefined,
    definitions: AttributeDefinitionDto[],
    extractor: (a: AttributeDefinitionActionDto) => T | undefined,
): T | undefined {
    if (!attributes || attributes.length === 0) {
        return undefined
    }
    for (const attribute of attributes) {
        const definition = definitions.find(d => d.id === attribute.definitionId)
        if (!definition?.actions?.length) {
            continue
        }
        const values = stringifyValues(attribute.value)
        if (values.length === 0) {
            continue
        }
        const resolved = resolvePerAttribute(definition.actions, values, extractor)
        if (resolved !== undefined && resolved !== null) {
            return resolved
        }
    }
    return undefined
}
